import React from 'react';

import { CheckCircleOutline, ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  capitalize,
  Grid,
} from '@mui/material';

import * as colors from 'commons/styles/colors';
import { ISTOPickItemWithSummary } from 'commons/types';

import { STOPickSummaryPageStyle as S } from '../STOPickSummaryPage.style';

import { STOPickBinList } from './STOPickBinList.component';

interface STOSkuListProps {
  stoItems: ISTOPickItemWithSummary[];
  headerText: string;
  headerIcon?: React.JSX.Element;
  headerColor?: string;
  defaultExpanded?: boolean;
}
export const STOSkuList: React.FC<STOSkuListProps> = ({
  stoItems,
  headerText,
  defaultExpanded,
  headerColor,
  headerIcon,
}) => {
  return (
    <>
      <S.HeaderWrapper>
        <S.Header color={headerColor || colors.PRIMARY_GREEN}>
          {headerIcon || <CheckCircleOutline />} {capitalize(headerText)}
        </S.Header>
      </S.HeaderWrapper>
      {stoItems.map((item, i) => {
        const qtyColor =
          item.quantity === item.pickedQty
            ? colors.PRIMARY_GREEN
            : item.pickedQty === 0
            ? colors.PRIMARY_BLACK
            : colors.PRIMARY_YELLOW;
        return (
          <Accordion
            defaultExpanded={item.pick_actual.length !== 0 && defaultExpanded}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls={`panel${i}-content`}
              id={`panel${i}-header`}
            >
              <Grid container style={{ fontWeight: 700 }}>
                <Grid item xs={8} data-testid={`TextSTSummarySKU-${i + 1}`}>
                  {item.sku_code}{' '}
                  <S.STONumberText>{item.sto_number}</S.STONumberText>
                </Grid>
                <Grid
                  item
                  xs={4}
                  style={{
                    textAlign: 'right',
                    verticalAlign: 'middle',
                    color: qtyColor,
                  }}
                >
                  {item.pickedQty} / {item.quantity}
                </Grid>
                <Grid item xs={12} data-testid={`TextNameSummarySKU-${i + 1}`}>
                  <S.SubHeaderText>{item.name}</S.SubHeaderText>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Grid />
              <STOPickBinList pickActual={item.pick_actual} />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};
